import React, { FC } from 'react';

type Props = {
    buttons: React.ReactElement[];
    content: React.ReactElement | React.ReactElement[] | string;
    heading: React.ReactElement | React.ReactElement[] | string;
};

export const Banner: FC<Props> = ({ buttons, content, heading }: Props) => {
    return (
        <div className="fixed bottom-0">
            <div className="card bg-neutral text-neutral-content">
                <div className="card-body items-center text-center">
                    <h2 className="card-title">{heading}</h2>
                    <p>{content}</p>
                    <div className="card-actions justify-center md:justify-end">
                        {buttons}
                    </div>
                </div>
            </div>
        </div>
    );
};
